/* WG cart drawer — slide-out panel, opens on header cart icon + after any
   add-to-cart. Talks to Shopify's Ajax Cart API (/cart.js, /cart/change.js).
   No dependency on the theme's stock (unused) cart-drawer-component. */
(function () {
  'use strict';
  if (window.__wgCartDrawer) return;
  window.__wgCartDrawer = true;

  var wrap = document.querySelector('[data-wg-cart-drawer]');
  if (!wrap) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var itemsEl = wrap.querySelector('[data-wg-cd-items]');
  var emptyEl = wrap.querySelector('[data-wg-cd-empty]');
  var footEl = wrap.querySelector('[data-wg-cd-foot]');
  var countEl = wrap.querySelector('[data-wg-cd-count]');
  var subtotalEl = wrap.querySelector('[data-wg-cd-subtotal]');
  var upsellWrap = wrap.querySelector('[data-wg-cd-upsell]');
  var upsellRow = wrap.querySelector('[data-wg-cd-upsell-row]');
  var moneyEl = document.querySelector('[data-wg-cd-money]');
  var backorderEl = document.querySelector('[data-wg-cd-backorders]');
  var backorderMessages = {};
  try {
    backorderMessages = JSON.parse(backorderEl.textContent);
  } catch (e) {}

  var moneyFormat = '${{amount}}';
  try {
    moneyFormat = JSON.parse(moneyEl.textContent);
  } catch (e) {}

  // Buyer's country, resolved once. Set on the wrapper by the drawer section.
  var WG_COUNTRY = wrap.getAttribute('data-wg-country') || 'US';

  // cents — US $100, international $120. Keep in sync with the announcement bar
  // (sections/header-group.json) and the Shopify shipping profile.
  var FREE_SHIPPING_THRESHOLD = WG_COUNTRY === 'US' ? 10000 : 12000;

  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function thumb(url) {
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_x160$1$2');
  }

  function updateBadge(cart) {
    document.querySelectorAll('[data-wg-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = !cart.item_count;
    });
  }

  function renderUpsell(products) {
    if (!upsellWrap || !upsellRow) return;
    if (!products || !products.length) {
      upsellWrap.hidden = true;
      upsellRow.innerHTML = '';
      return;
    }
    upsellWrap.hidden = false;
    upsellRow.innerHTML = products
      .filter(function (p) {
        return p && p.url;
      })
      .slice(0, 4)
      .map(function (p) {
        return (
          '<li class="wg-cd__upsell-item">' +
          '<div class="wg-cd__upsell-media">' +
          '<a href="' +
          p.url +
          '">' +
          (p.featured_image
            ? '<img src="' + thumb(p.featured_image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">'
            : '') +
          '</a>' +
          '<button type="button" class="wg-cd__upsell-add wg-qa" data-wg-cd-upsell-add data-url="' +
          p.url +
          '" aria-label="View ' +
          escapeHtml(p.title) +
          '">' +
          '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 2v12M2 8h12" stroke="currentColor" stroke-width="1.3"/></svg>' +
          '</button>' +
          '</div>' +
          '<div class="wg-cd__upsell-info">' +
          '<a class="wg-cd__upsell-item-title" href="' +
          p.url +
          '">' +
          escapeHtml(p.title) +
          '</a>' +
          '<span class="wg-cd__upsell-price">' +
          money(p.price) +
          '</span>' +
          '</div>' +
          '</li>'
        );
      })
      .join('');
  }

  function fetchUpsell(cart) {
    if (!upsellWrap || !upsellRow) return;
    if (!cart.items.length) {
      renderUpsell([]);
      return;
    }
    var lastItem = cart.items[cart.items.length - 1];
    fetch(root + 'recommendations/products.json?product_id=' + lastItem.product_id + '&limit=4&intent=related', {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var products = (data && data.products) || [];
        var cartProductIds = cart.items.map(function (i) {
          return i.product_id;
        });
        products = products.filter(function (p) {
          return (
            cartProductIds.indexOf(p.id) === -1 &&
            !!p.url &&
            p.variants &&
            p.variants.some(function (v) {
              return v.available;
            })
          );
        });
        renderUpsell(products);
      })
      .catch(function () {
        renderUpsell([]);
      });
  }

  function render(cart) {
    updateBadge(cart);
    countEl.textContent = cart.item_count;
    var shipBlock = wrap.querySelector('[data-wg-cd-shipping]');
    var shipMsg = wrap.querySelector('[data-wg-cd-shipping-msg]');
    var shipFill = wrap.querySelector('[data-wg-cd-shipping-fill]');
    if (shipBlock && shipMsg && shipFill) {
      var countryCode = WG_COUNTRY;
      var hasSuitcase = (cart.items || []).some(function (it) { return it.handle === 'suitcase'; });
      if (countryCode !== 'US' && hasSuitcase) {
        shipBlock.hidden = true;
      } else {
        shipBlock.hidden = false;
        var remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
        if (remaining <= 0) {
          shipMsg.innerHTML = 'You\'ve unlocked <strong>free shipping!</strong>';
        } else {
          shipMsg.innerHTML = 'You\'re <strong>' + money(remaining) + '</strong> away from free shipping';
        }
        var pct = Math.max(0, Math.min(100, Math.round((cart.total_price / FREE_SHIPPING_THRESHOLD) * 100)));
        shipFill.style.width = pct + '%';
      }
    }
    if (!cart.items.length) {
      emptyEl.hidden = false;
      itemsEl.hidden = true;
      footEl.hidden = true;
      itemsEl.innerHTML = '';
      fetchUpsell(cart);
      return;
    }
    emptyEl.hidden = true;
    itemsEl.hidden = false;
    footEl.hidden = false;
    var subtotal = typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : cart.total_price;
    subtotalEl.textContent = money(subtotal);

    itemsEl.innerHTML = cart.items
      .map(function (item) {
        return (
          '<li class="wg-cd__item" data-key="' +
          escapeHtml(item.key) +
          '">' +
          '<a class="wg-cd__item-media" href="' +
          item.url +
          '">' +
          (item.image
            ? '<img src="' + thumb(item.image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
            : '') +
          '</a>' +
          '<div class="wg-cd__item-info">' +
          '<a class="wg-cd__item-title" href="' +
          item.url +
          '">' +
          escapeHtml(item.product_title) +
          '</a>' +
          (item.variant_title
            ? '<span class="wg-cd__item-variant">' + escapeHtml(item.variant_title) + '</span>'
            : '') +
          (backorderMessages[item.variant_id]
            ? '<p class="wg-backorder">' + escapeHtml(backorderMessages[item.variant_id]) + '</p>'
            : '') +
          '<div class="wg-cd__item-row">' +
          '<div class="wg-cd__qty">' +
          '<button type="button" class="wg-cd__qty-btn" data-wg-cd-qty="-1" aria-label="Decrease quantity">' +
          "−" +
          '</button>' +
          '<span class="wg-cd__qty-val">' +
          item.quantity +
          '</span>' +
          '<button type="button" class="wg-cd__qty-btn" data-wg-cd-qty="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<span class="wg-cd__item-price">' +
          money(item.line_price) +
          '</span>' +
          '</div>' +
          '</div>' +
          '<button type="button" class="wg-cd__item-remove" data-wg-cd-remove aria-label="Remove item">' +
          '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m3 3 10 10M13 3 3 13" stroke="currentColor" stroke-width="1.1"/></svg>' +
          '</button>' +
          '</li>'
        );
      })
      .join('');

    fetchUpsell(cart);
  }

  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function changeQty(key, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(render)
      .catch(function () {});
  }

  function open() {
    wrap.classList.add('is-open');
    wrap.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wg-cd-lock');
  }

  function close() {
    wrap.classList.remove('is-open');
    wrap.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('wg-cd-lock');
  }

  function openWithFreshCart() {
    fetchCart().then(function (cart) {
      render(cart);
      open();
    });
  }

  itemsEl.addEventListener('click', function (e) {
    var row = e.target.closest('.wg-cd__item');
    if (!row) return;
    var key = row.getAttribute('data-key');

    var qtyBtn = e.target.closest('[data-wg-cd-qty]');
    if (qtyBtn) {
      var delta = parseInt(qtyBtn.getAttribute('data-wg-cd-qty'), 10);
      var valEl = row.querySelector('.wg-cd__qty-val');
      var newQty = Math.max(0, parseInt(valEl.textContent, 10) + delta);
      changeQty(key, newQty);
      return;
    }

    if (e.target.closest('[data-wg-cd-remove]')) {
      changeQty(key, 0);
    }
  });

  if (upsellRow) {
    upsellRow.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-wg-cd-upsell-add]');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        var url = addBtn.getAttribute('data-url');
        if (!url) return;
        try { sessionStorage.setItem('wg-cd-reopen', '1'); } catch (err) {}
        window.location.href = url;
        return;
      }
      var link = e.target.closest('a');
      if (link) {
        try { sessionStorage.setItem('wg-cd-reopen', '1'); } catch (err) {}
        // let default navigation proceed naturally
      }
    });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-wg-cart-link]');
    if (opener) {
      e.preventDefault();
      openWithFreshCart();
      return;
    }
    if (e.target.closest('[data-wg-cd-close]') || e.target.closest('[data-wg-cd-backdrop]')) {
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && wrap.classList.contains('is-open')) close();
  });

  ['wg:cart:update', 'cart:update'].forEach(function (name) {
    document.addEventListener(name, openWithFreshCart);
  });

  try {
    if (sessionStorage.getItem('wg-cd-reopen')) {
      sessionStorage.removeItem('wg-cd-reopen');
      openWithFreshCart();
    }
  } catch (err) {}
})();
